import { lazy } from "react";
import { ElementDetails } from "@/lib/types";

export const details = {
  name: "StickyNotes",
  description:
    "Note widget to quickly write your thoughts or take important notes",
  tags: ["Productivity", "Organization"],
  category: "Widget",
  grid: { default: [2, 2] },
  context: lazy(() =>
    import("./Context").then(m => ({ default: m.StickyNoteContext })),
  ),
  defaultProps: {
    backgroundColor: "bg-yellow-300",
    textSize: "18px",
  },
} satisfies ElementDetails;
